import { render, staticRenderFns } from "./CombosComboboxMT.vue?vue&type=template&id=2aa3a58a"
import script from "./CombosComboboxMT.vue?vue&type=script&lang=js"
export * from "./CombosComboboxMT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports